import React from 'react';

import PropTypes from 'prop-types';

import UserDateTimezoneFormat from '../../components/user-date-timezone-format';
import { UserDateTimePropType } from '../../prop-types/user-date-time';

const PickupTime = ({ className, pickupDateTime, emptyValue }) => {
  return (
    <div className={className}>
      {pickupDateTime ? <UserDateTimezoneFormat dateTime={pickupDateTime} showTime spaceBetweenTimeAndZone /> : emptyValue}
    </div>
  );
};

PickupTime.propTypes = {
  className: PropTypes.string,
  pickupDateTime: UserDateTimePropType,
  emptyValue: PropTypes.node,
};

export default PickupTime;
